import { Injectable, OnDestroy } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

export const ToasterType = {
  Success: 'success',
  Error: 'error',
  Info: 'info'
}

export interface Toaster {
  type: 'success' | 'error' | 'info';
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private toastr$: Subject<Toaster> = new Subject<Toaster>();

  constructor(protected toastrService: ToastrService) {
    this.toastr$
      .asObservable()
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(toast => {
        if (toast.type === 'success') {
          this.toastrService.success(toast.message, 'Success');
        } else if (toast.type === 'error') {
          alert(toast.message);
          // TODO if you wanna switch to toaster
          // this.toastrService.error(toast.message, 'Error')
        }
      })
  }

  cleanup(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  show(toast: Toaster): void {
    this.toastr$.next(toast);
  }
}
